import { createStore } from 'vuex'

export default createStore({
  state: {
    routerTitle: "",
    routerPath: "",
    userName: "",
  },
  getters: {
  },
  mutations: {
    routerTitleChange(state, value) {
      state.routerTitle = value;
    },
    routerPathChange(state, value) {
      state.routerPath = value;
    },
    userNameChange(state, value) {
      state.userName = value;
    },
  },
  actions: {
  },
  modules: {
  }
})
